import type { SVGProps } from 'react';
import * as React from 'react';
const SvgMoonset = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}>
    <path
      d="M2.712 10.19c.354-.1.56-.469.46-.823a5.021 5.021 0 0 1 4.827-6.384 5.021 5.021 0 0 1 4.827 6.384.667.667 0 0 0 1.283.363 6.357 6.357 0 0 0-6.111-8.08 6.355 6.355 0 0 0-6.109 8.08c.1.355.469.562.823.46M15.211 12h-4.697a.665.665 0 0 0-.471.195L8 14.238l-2.043-2.043A.665.665 0 0 0 5.486 12H.789a.667.667 0 0 0 0 1.334H5.21l2.319 2.319a.665.665 0 0 0 .942 0l2.319-2.319h4.421a.667.667 0 0 0 0-1.334"
      fill="currentColor"
    />
  </svg>
);
export default SvgMoonset;
